import { useTransferCountsStore } from "@/store/TransferCounts";
import { useWindowStore } from "@/store/WindowWidth";
import { tw } from "@/utils";
import React, { useState } from "react";

interface StatusItem {
  key: string;
  value: string;
}

interface StatusFilterProps {
  status: StatusItem[];
  onChange?: (selectedKey: string) => void;
  defaultSelected?: string;
  className?: string;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  status,
  onChange,
  defaultSelected,
  className,
}) => {
  const [filterStatus, setFilterStatus] = useState<string>(
    defaultSelected || (status.length > 0 ? status[0].key : "")
  );

  const { width } = useWindowStore();
  const { transferStatusCounts } = useTransferCountsStore();

  const isResponse = width < 1550;

  const handleStatusChange = (key: string) => {
    setFilterStatus(key);
    if (onChange) {
      onChange(key);
    }
  };

  return (
    <div
      className={`flex items-center w-fit h-[42px] bg-gray-g30 rounded-[8px] p-[4px] ${className || ""}`}
    >
      {status.map((item) => (
        <div
          key={item.key}
          className={tw(
            "flex items-center justify-center gap-[4px] w-[122px] h-[34px] rounded-[6px] cursor-pointer text-base font-medium text-gray-g200",
            item.key === filterStatus
              ? "bg-white text-gray-g500"
              : "bg-transparent",
            isResponse && "w-[82px]"
          )}
          onClick={() => handleStatusChange(item.key)}
        >
          {item.value}
          {item.key === "in_progress" &&
            transferStatusCounts.in_progress !== 0 && (
              <div
                className={tw(
                  "flex items-center justify-center",
                  "w-[20px] h-[20px] rounded-full text-white text-xs font-medium bg-red leading-[16px]"
                )}
              >
                {transferStatusCounts.in_progress}
              </div>
            )}
        </div>
      ))}
    </div>
  );
};

export default StatusFilter;
